import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2022EvidenciasFotograficas() {
  return <CategoryPage category="anexo30Y31Ano2022EvidenciasFotograficas" pageTitle="Evidencias Fotograficas 2022" />;
}

export default Anexo30Y31Ano2022EvidenciasFotograficas;
